/** Estado da resposta no Google (reviewReply.reviewReplyState) e o motivo quando recusada. */
export type ModeracaoDaResposta = {
  replyState?: string | null;
  policyViolation?: string | null;
};

export const respostaRecusada = (r: ModeracaoDaResposta): boolean =>
  r.replyState === 'REJECTED' || !!r.policyViolation?.trim();

export const respostaEmAnalise = (r: ModeracaoDaResposta): boolean =>
  r.replyState === 'PENDING' && !respostaRecusada(r);

const MOTIVOS: Record<string, string> = {
  ADVERTISING_AND_SOLICITATION: 'propaganda ou pedido de contato',
  OFF_TOPIC: 'fora do assunto da avaliação',
  GIBBERISH_AND_REPETITIVE: 'texto sem sentido ou repetitivo',
  REPETITIVE: 'texto repetitivo',
  UNCLEAR: 'texto confuso',
  PERSONAL_INFO: 'dados pessoais',
  PRIVACY: 'privacidade',
  OFFENSIVE: 'conteúdo ofensivo',
  OBSCENITY_AND_PROFANITY: 'palavrão ou obscenidade',
  HARASSMENT: 'assédio',
  HATE_SPEECH: 'discurso de ódio',
  IMPERSONATION: 'falsa identidade',
  MISINFORMATION: 'informação falsa',
  MISREPRESENTATION: 'informação enganosa',
  FAKE_ENGAGEMENT: 'engajamento falso',
  ILLEGAL: 'conteúdo ilegal',
  DANGEROUS: 'conteúdo perigoso',
  REGULATED_GOODS_AND_SERVICES: 'produto ou serviço regulado',
  GENERIC_VIOLATION: 'viola a política do Google',
  GENERIC_QUALITY: 'baixa qualidade',
};

const traduzir = (codigo: string): string => MOTIVOS[codigo] ?? `política do Google (${codigo})`;

/**
 * O backend guarda o policyViolation como JSON cru: hoje a API manda um enum
 * ("OFF_TOPIC"), mas o formato não é garantido — objeto vira o primeiro texto que tiver.
 */
export const motivoDaRecusa = (violacaoCrua?: string | null): string | null => {
  const bruto = violacaoCrua?.trim();
  if (!bruto) return null;
  let valor: unknown;
  try {
    valor = JSON.parse(bruto);
  } catch {
    return traduzir(bruto);
  }
  if (typeof valor === 'string') return valor.trim() ? traduzir(valor.trim()) : null;
  if (valor && typeof valor === 'object') {
    const texto = Object.values(valor as Record<string, unknown>).find(
      (v): v is string => typeof v === 'string' && v.trim() !== '',
    );
    return texto ? traduzir(texto.trim()) : bruto;
  }
  return bruto;
};

/** Respostas que o Google recusou dentro dos últimos `dias` (pela data em que o sync viu a recusa). */
export const recusadasNoPeriodo = (
  reviews: { recusadaEm?: string | null }[] | null | undefined,
  dias: number,
  hoje: Date = new Date(),
): number => {
  const limite = hoje.getTime() - dias * 86_400_000;
  return (reviews ?? []).filter((r) => {
    if (!r.recusadaEm) return false;
    const quando = new Date(r.recusadaEm).getTime();
    return Number.isFinite(quando) && quando >= limite && quando <= hoje.getTime() + 86_400_000;
  }).length;
};
